<template>
  <div class="card-form">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        :currencyUnit="currencyUnit"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageTable from './table.vue'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: {
    evgPurchaseCode: { type: String, default: '' },
    currencyUnit: { type: String, default: '' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.evgPurchaseCode) return
      this.loading = true
      this.$api
        .ecomEvgPurchaseDetailOptionsApi({
          ...form,
          ...this.page,
          evgPurchaseCode: this.evgPurchaseCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
    },
  },
}
</script>
